import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SupervisorView from './SupervisorView';
import TechnicianView from './TechnicianView';
import * as Fathom from 'fathom-client';

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Fathom when the app loads
    Fathom.load('WPLJSQGB', {
      includedDomains: ['dipswitch.powerio.com']
    });

    // Track pageviews on route change
    const handleRouteChange = () => {
      Fathom.trackPageview();
    };

    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<SupervisorView />} />
        <Route path="/supervisor/edit/:encodedConfig" element={<SupervisorView />} />
        <Route path="/technician/:encodedConfig" element={<TechnicianView />} />
      </Routes>
    </Router>
  );
};

export default App;
